// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.17 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-emerald-50: oklch(97.9% 0.021 166.113);
    --color-emerald-100: oklch(95% 0.052 163.051);
    --color-emerald-200: oklch(90.5% 0.093 164.15);
    --color-emerald-700: oklch(50.8% 0.118 165.612);
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-6xl: 72rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --blur-3xl: 64px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::-moz-placeholder {
    opacity: 1;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::-moz-placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    -webkit-appearance: button;
       -moz-appearance: button;
            appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .-top-24 {
    top: calc(var(--spacing) * -24);
  }
  .top-10 {
    top: calc(var(--spacing) * 10);
  }
  .right-6 {
    right: calc(var(--spacing) * 6);
  }
  .right-10 {
    right: calc(var(--spacing) * 10);
  }
  .bottom-6 {
    bottom: calc(var(--spacing) * 6);
  }
  .left-10 {
    left: calc(var(--spacing) * 10);
  }
  .z-50 {
    z-index: 50;
  }
  .order-1 {
    order: 1;
  }
  .order-2 {
    order: 2;
  }
  .order-3 {
    order: 3;
  }
  .mx-auto {
    margin-inline: auto;
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .inline-flex {
    display: inline-flex;
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-60 {
    height: calc(var(--spacing) * 60);
  }
  .h-72 {
    height: calc(var(--spacing) * 72);
  }
  .max-h-0 {
    max-height: calc(var(--spacing) * 0);
  }
  .max-h-\\[520px\\] {
    max-height: 520px;
  }
  .max-h-\\[560px\\] {
    max-height: 560px;
  }
  .max-h-\\[5000px\\] {
    max-height: 5000px;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-60 {
    width: calc(var(--spacing) * 60);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-full {
    width: 100%;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-6xl {
    max-width: var(--container-6xl);
  }
  .max-w-7xl {
    max-width: var(--container-7xl);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .flex-1 {
    flex: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .resize {
    resize: both;
  }
  .list-disc {
    list-style-type: disc;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-10 {
    gap: calc(var(--spacing) * 10);
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-\\[var\\(--accent\\)\\] {
    border-color: var(--accent);
  }
  .border-emerald-200 {
    border-color: var(--color-emerald-200);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-white\\/50 {
    border-color: color-mix(in srgb, #fff 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 50%, transparent);
    }
  }
  .border-white\\/60 {
    border-color: color-mix(in srgb, #fff 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 60%, transparent);
    }
  }
  .border-white\\/70 {
    border-color: color-mix(in srgb, #fff 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 70%, transparent);
    }
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .bg-\\[var\\(--accent\\)\\] {
    background-color: var(--accent);
  }
  .bg-\\[var\\(--accent-2\\)\\] {
    background-color: var(--accent-2);
  }
  .bg-\\[var\\(--bg\\)\\] {
    background-color: var(--bg);
  }
  .bg-emerald-50\\/70 {
    background-color: color-mix(in srgb, oklch(97.9% 0.021 166.113) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-emerald-50) 70%, transparent);
    }
  }
  .bg-emerald-100 {
    background-color: var(--color-emerald-100);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white\\/50 {
    background-color: color-mix(in srgb, #fff 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 50%, transparent);
    }
  }
  .bg-white\\/60 {
    background-color: color-mix(in srgb, #fff 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 60%, transparent);
    }
  }
  .bg-white\\/70 {
    background-color: color-mix(in srgb, #fff 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 70%, transparent);
    }
  }
  .bg-white\\/80 {
    background-color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-12 {
    padding-top: calc(var(--spacing) * 12);
  }
  .pt-14 {
    padding-top: calc(var(--spacing) * 14);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-12 {
    padding-bottom: calc(var(--spacing) * 12);
  }
  .pb-14 {
    padding-bottom: calc(var(--spacing) * 14);
  }
  .pb-16 {
    padding-bottom: calc(var(--spacing) * 16);
  }
  .pb-20 {
    padding-bottom: calc(var(--spacing) * 20);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-4xl {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[0\\.2em\\] {
    --tw-tracking: 0.2em;
    letter-spacing: 0.2em;
  }
  .tracking-\\[0\\.3em\\] {
    --tw-tracking: 0.3em;
    letter-spacing: 0.3em;
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .text-\\[var\\(--accent\\)\\] {
    color: var(--accent);
  }
  .text-\\[var\\(--accent-2\\)\\] {
    color: var(--accent-2);
  }
  .text-\\[var\\(--ink\\)\\] {
    color: var(--ink);
  }
  .text-\\[var\\(--muted\\)\\] {
    color: var(--muted);
  }
  .text-emerald-700 {
    color: var(--color-emerald-700);
  }
  .text-white {
    color: var(--color-white);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-25 {
    opacity: 25%;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow-\\[0_18px_40px_rgba\\(227\\,108\\,79\\,0\\.35\\)\\] {
    --tw-shadow: 0 18px 40px var(--tw-shadow-color, rgba(227,108,79,0.35));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .blur-3xl {
    --tw-blur: blur(var(--blur-3xl));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .hover\\:-translate-y-0\\.5 {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .hover\\:border-white\\/80 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in srgb, #fff 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-white) 80%, transparent);
        }
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:shadow-lg {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .disabled\\:opacity-60 {
    &:disabled {
      opacity: 60%;
    }
  }
  .md\\:col-span-2 {
    @media (width >= 48rem) {
      grid-column: span 2 / span 2;
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .md\\:flex-row {
    @media (width >= 48rem) {
      flex-direction: row;
    }
  }
  .md\\:items-center {
    @media (width >= 48rem) {
      align-items: center;
    }
  }
  .md\\:p-8 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 8);
    }
  }
  .md\\:pb-0 {
    @media (width >= 48rem) {
      padding-bottom: calc(var(--spacing) * 0);
    }
  }
  .md\\:text-4xl {
    @media (width >= 48rem) {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
  }
  .md\\:text-5xl {
    @media (width >= 48rem) {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
  }
  .lg\\:grid-cols-\\[1\\.1fr_0\\.9fr\\] {
    @media (width >= 64rem) {
      grid-template-columns: 1.1fr 0.9fr;
    }
  }
  .lg\\:grid-cols-\\[1\\.2fr_0\\.8fr\\] {
    @media (width >= 64rem) {
      grid-template-columns: 1.2fr 0.8fr;
    }
  }
}
:root {
  --bg: #f6f1e7;
  --surface: rgba(255, 255, 255, 0.86);
  --ink: #1f1b16;
  --muted: #5c5650;
  --accent: #e36c4f;
  --accent-2: #1f7a72;
  --accent-3: #f3b769;
  --desktop-results-panel-width: 380px;
  --page-max-width: 80rem;
  --results-panel-gap: 24px;
}
body {
  margin: 0;
  font-family: "Instrument Sans", system-ui, sans-serif;
  color: var(--ink);
  background: var(--bg);
  overflow-x: hidden;
}
html.results-only,
body.results-only {
  overflow: hidden;
}
html {
  background: var(--bg);
  scroll-behavior: auto;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
       text-size-adjust: 100%;
  overflow-x: hidden;
}
#root {
  width: 100%;
  overflow-x: hidden;
}
* {
  box-sizing: border-box;
}
@layer base {
  h1,
  h2,
  h3,
  h4 {
    font-family: "Space Grotesk", system-ui, sans-serif;
  }
}
@layer components {
  .glass-card {
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.65);
    background: var(--surface);
    max-width: 100%;
    width: 100%;
    box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
    backdrop-filter: none;
    transition: border-color 220ms ease;
  }
  .glass-card:hover {
    border-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.1);
  }
  .input-field,
  .select-field {
    width: 100%;
    max-width: 100%;
    border-radius: 14px;
    border: 1px solid rgba(15, 23, 42, 0.12);
    background: rgba(255, 255, 255, 0.92);
    padding: 10px 12px;
    font-size: 0.9rem;
    transition: border 160ms ease, box-shadow 160ms ease,
      transform 160ms ease;
  }
  .input-field:focus,
  .select-field:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(227, 108, 79, 0.2);
    transform: translateY(-1px);
  }
  .input-field.is-error,
  .select-field.is-error {
    border-color: var(--accent);
  }
  .segmented {
    display: inline-flex;
    flex-wrap: wrap;
    max-width: 100%;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, 0.7);
    padding: 4px;
    gap: 4px;
  }
  .segmented-button {
    border-radius: 999px;
    max-width: 100%;
    padding: 6px 12px;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--muted);
    transition: all 150ms ease;
  }
  .segmented-button.is-active {
    background: white;
    color: var(--ink);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
  }
  .comparison-label {
    text-transform: uppercase;
    letter-spacing: 0.12em;
    line-height: 1.3;
    overflow-wrap: normal;
    word-break: normal;
    text-wrap: balance;
    hyphens: manual;
  }
  .comparison-card {
    min-width: 0;
  }
  .glass-card > * {
    min-width: 0;
  }
  @media (max-width: 640px) {
    .comparison-label {
      letter-spacing: 0.12em;
    }
  }
  .fire-logo {
    position: relative;
    display: grid;
    place-items: center;
    border-radius: 999px;
    background: transparent;
    box-shadow: none;
    overflow: visible;
    isolation: isolate;
  }
  .fire-logo__img {
    width: 70%;
    height: 70%;
    -o-object-fit: contain;
       object-fit: contain;
    position: relative;
    z-index: 4;
    filter: none;
  }
  .fire-logo__flames,
  .fire-logo__smoke,
  .fire-logo__embers {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -62%);
    pointer-events: none;
  }
  .fire-logo__flames {
    z-index: 2;
    mix-blend-mode: normal;
    opacity: 0.55;
    filter: none;
  }
  .fire-logo__smoke {
    z-index: 1;
    opacity: 0.18;
    mix-blend-mode: normal;
  }
  .fire-logo__embers {
    z-index: 3;
    opacity: 0.3;
    mix-blend-mode: normal;
  }
  .fire-logo__heat {
    position: absolute;
    top: -35%;
    left: -10%;
    width: 120%;
    height: 110%;
    border-radius: 999px;
    background-image: radial-gradient(
        60% 40% at 50% 60%,
        rgba(255, 255, 255, 0.12),
        transparent 70%
      ),
      radial-gradient(
        40% 30% at 30% 40%,
        rgba(255, 190, 120, 0.12),
        transparent 70%
      );
    opacity: 0.12;
    filter: none;
    mix-blend-mode: normal;
    z-index: 7;
    animation: none;
    pointer-events: none;
    -webkit-mask-image: radial-gradient(
      circle at 50% 60%,
      rgba(0, 0, 0, 1),
      transparent 70%
    );
    mask-image: radial-gradient(
      circle at 50% 60%,
      rgba(0, 0, 0, 1),
      transparent 70%
    );
  }
  .hero-gradient {
    background-image: radial-gradient(
        circle at 10% 10%,
        rgba(243, 183, 105, 0.35),
        transparent 55%
      ),
      radial-gradient(
        circle at 80% 20%,
        rgba(31, 122, 114, 0.25),
        transparent 55%
      ),
      linear-gradient(
        130deg,
        rgba(255, 255, 255, 0.7),
        rgba(255, 255, 255, 0.1)
    );
    background-size: 200% 200%;
    animation: none;
  }
  .accuracy-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 12px calc(env(safe-area-inset-bottom, 0px) + 10px);
    background: rgba(255, 255, 255, 0.82);
    backdrop-filter: none;
    border-top: 1px solid rgba(255, 255, 255, 0.6);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);
    transform: translateY(110%);
    opacity: 0;
    transition: transform 220ms ease, opacity 220ms ease;
    z-index: 50;
  }
  .accuracy-bar.is-visible {
    transform: translateY(0);
    opacity: 1;
  }
  .accuracy-bar__inner {
    max-width: 640px;
    margin: 0 auto;
    padding: 8px 12px 6px;
    border-radius: 16px 16px 10px 10px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, 0.92);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .accuracy-bar__label {
    font-size: 0.65rem;
    text-transform: uppercase;
    letter-spacing: 0.3em;
    color: var(--muted);
  }
  .accuracy-bar__note {
    margin-top: 4px;
    font-size: 0.75rem;
    color: var(--muted);
  }
  .accuracy-bar__help {
    width: 32px;
    height: 32px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    background: white;
    color: var(--ink);
    font-weight: 700;
    display: grid;
    place-items: center;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
  }
  .accuracy-bar__actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  .accuracy-bar__results {
    border-radius: 999px;
    background: var(--accent);
    color: white;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 6px 12px;
    box-shadow: 0 10px 22px rgba(227, 108, 79, 0.25);
  }
  .accuracy-bar__track {
    max-width: 640px;
    margin: 6px auto 0;
    height: 6px;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.08);
    overflow: hidden;
  }
  .accuracy-bar__fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--accent-2), var(--accent));
    transition: none;
  }
  .accuracy-modal {
    position: fixed;
    inset: 0;
    z-index: 60;
    display: grid;
    place-items: center;
    padding: 20px;
  }
  .accuracy-modal__backdrop {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.25);
    backdrop-filter: none;
    border: none;
  }
  .accuracy-modal__card {
    position: relative;
    z-index: 1;
    width: min(92vw, 360px);
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
    padding: 18px;
  }
  .accuracy-modal__value {
    font-size: 2rem;
    font-weight: 700;
    color: var(--ink);
  }
  .accuracy-modal__track {
    margin-top: 10px;
    height: 10px;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.08);
    overflow: hidden;
  }
  .accuracy-modal__fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--accent-2), var(--accent));
    transition: width 600ms ease;
  }
  .accuracy-modal__close {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.18em;
    color: var(--muted);
  }
}
@layer utilities {
  .animate-float {
    animation: none;
  }
  .animate-float-slow {
    animation: none;
  }
}
@media (max-width: 768px) {
  .glass-card {
    backdrop-filter: none;
  }
  body {
    padding-bottom: 82px;
  }
  .accuracy-bar {
    display: block;
  }
  .show-results-fab {
    display: none;
  }
  .hero-container {
    padding-top: 32px;
  }
  .hero-pill {
    max-width: 100%;
  }
  .accuracy-gauge {
    display: none;
  }
  .hero-title {
    font-size: 1.8rem;
    line-height: 1.25;
  }
  .hero-subtitle {
    font-size: 0.9rem;
  }
  .hero-container {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .accuracy-bar__inner {
    padding: 8px 10px;
  }
  .accuracy-bar__note {
    font-size: 0.7rem;
  }
  .accuracy-modal {
    padding: 16px;
  }
  .workout-row,
  .exercise-row,
  .session-row {
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .workout-row button,
  .exercise-row button,
  .session-row button {
    min-width: 0;
  }
  .workout-row span,
  .exercise-row span,
  .session-row span {
    white-space: normal;
  }
  .workout-row > button,
  .exercise-row > button,
  .session-row > button {
    flex: 1 1 100%;
    justify-content: flex-start;
  }
  .exercise-actions {
    width: 100%;
    justify-content: space-between;
  }
  .workout-row__remove,
  .exercise-row__remove,
  .session-row__remove {
    margin-left: auto;
  }
  html.results-only,
  body.results-only {
    overflow: auto;
  }
  html.results-only {
    font-size: 16px;
  }
}
@media (min-width: 769px) {
  html.results-only {
    font-size: 15px;
  }
  .accuracy-bar {
    display: none;
  }
}
@media (max-width: 360px) {
  .hero-title {
    font-size: 1.55rem;
  }
  .hero-subtitle {
    font-size: 0.85rem;
  }
  .hero-container {
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .accuracy-bar__actions {
    gap: 6px;
  }
  .accuracy-bar__results {
    padding: 5px 10px;
    font-size: 0.7rem;
  }
}
@media (min-width: 1024px) {
  .results-grid {
    min-height: calc(100vh - 220px);
  }
  .results-panel--compact {
    min-height: calc(100vh - 240px);
  }
  .results-layout--desktop {
    display: block;
    position: relative;
    gap: 32px;
    align-items: start;
  }
  .results-layout__main {
    min-width: 0;
    transition: padding-right 260ms ease;
  }
  .results-layout--desktop.is-expanded .results-layout__main {
    padding-right: calc(
      var(--desktop-results-panel-width) + var(--results-panel-gap)
    );
  }
  .results-layout__panel {
    position: fixed;
    top: 24px;
    height: calc(100vh - 48px);
    width: var(--desktop-results-panel-width);
    right: max(
      16px,
      calc((100vw - var(--page-max-width)) / 2 + 16px)
    );
    z-index: 20;
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 24px;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.1);
    padding: 20px 16px 24px;
    overflow: hidden;
    opacity: 0;
    transform: translateX(16px);
    pointer-events: none;
    transition: opacity 260ms ease, transform 260ms ease;
    will-change: opacity, transform;
  }
  .results-layout.is-expanded .results-layout__panel {
    opacity: 1;
    transform: translateX(0);
    pointer-events: auto;
  }
  .results-layout__panel-inner {
    height: 100%;
    overflow-y: auto;
    padding: 0;
    border-radius: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .results-layout__panel-inner .glass-card {
    border-radius: 16px;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.98);
  }
  #calculator {
    overflow: visible;
  }
  .results-grid {
    width: 100%;
    align-items: stretch;
    overflow: visible;
    position: relative;
  }
  .results-grid > * {
    min-width: 0;
  }
  .results-sidebar {
    position: relative;
    align-self: stretch;
    background: transparent;
    max-height: none;
    overflow: visible;
  }
  .results-sidebar__inner {
    width: 100%;
    position: sticky;
    top: 24px;
    height: -moz-fit-content;
    height: fit-content;
  }
  .results-sidebar .glass-card {
    border-radius: 20px;
  }
  .results-panel--compact {
    display: grid;
    gap: 14px;
    position: static;
  }
  .results-panel--compact .glass-card {
    padding: 12px;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  }
  .results-panel--compact h3,
  .results-panel--compact h4 {
    font-size: 0.98rem;
  }
  .results-panel--compact .text-lg {
    font-size: 0.98rem;
  }
  .results-panel--compact .text-2xl {
    font-size: 1.2rem;
  }
  .results-panel--compact .text-sm {
    font-size: 0.78rem;
  }
  .results-panel--compact .text-xs {
    font-size: 0.62rem;
  }
  .results-panel--compact .mt-6 {
    margin-top: 0.5rem;
  }
  .results-panel--compact .mt-5 {
    margin-top: 0.45rem;
  }
  .results-panel--compact .mt-4 {
    margin-top: 0.4rem;
  }
  .results-panel--compact .gap-4 {
    gap: 0.55rem;
  }
  .results-panel--compact .gap-3 {
    gap: 0.45rem;
  }
  .results-panel--compact .rounded-2xl {
    border-radius: 16px;
  }
  body.desktop-results-open .show-results-fab {
    right: calc(
      var(--desktop-results-panel-width) +
        var(--results-panel-gap) +
        24px
    );
  }
}
@media (min-width: 769px) and (max-height: 760px) {
  html.results-only {
    font-size: 14px;
  }
  .results-only-view > * + * {
    margin-top: 0.35rem;
  }
  .results-only-view .glass-card {
    padding: 10px;
  }
  .results-only-grid {
    gap: 0.4rem;
  }
}
@media (min-width: 769px) and (max-height: 680px) {
  html.results-only {
    font-size: 13px;
  }
}
@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-18px);
  }
}
@keyframes gradientShift {
  0%,
  100% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
}
@keyframes heatShimmer {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.25;
  }
  50% {
    transform: translate3d(2px, -6px, 0) scale(1.04);
    opacity: 0.4;
  }
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/index.css"],"names":[],"mappings":"AAAA,kEAAA;AC83BE,iBAAmB;AA93BrB,yCAAyC;AAEzC;EACE;IACE;6DAEyD;IAEzD;8BAE0B;IA0E1B,8CAA8C;IAC9C,6CAA6C;IAC7C,8CAA8C;IAK9C,+CAA+C;IA0L/C,mBAAmB;IAEnB,kBAAkB;IAclB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IAGtB,sBAAsB;IACtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAc1B,yBAAyB;IACzB,2BAA2B;IAU3B,wBAAwB;IAExB,qBAAqB;IAUrB,oBAAoB;IACpB,kBAAkB;IAwClB,2CAA2C;IAE3C,uCAAuC;IA4CvC,gBAAgB;IAUhB,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;EA5c5C;AADJ;AAmeb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAW;MAAX,cAAW;SAAX,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EAAd;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;IAAd;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,0BAAkB;OAAlB,uBAAkB;YAAlB,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,gTAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;QAAnB,sDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uDAAmB;QAAnB;UAAA,sEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+HAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;AADJ;AC13BjB;EACE,aAAc;EACd,oCAAqC;EACrC,cAAe;EACf,gBAAiB;EACjB,iBAAkB;EAClB,mBAAoB;EACpB,mBAAoB;EACpB,oCAAqC;EACrC,uBAAwB;EACxB,yBAA0B;AAC3B;AAED;EACE,SAAU;EACV,qDAAsD;EACtD,iBAAkB;EAClB,qBAAsB;EACtB,kBAAmB;AACpB;AAED;;EAEE,gBAAiB;AAClB;AAED;EACE,qBAAsB;EACtB,qBAAsB;EACtB,8BAA+B;EAC/B,2BAAuB;OAAvB,sBAAuB;EACvB,kBAAmB;AACpB;AAED;EACE,WAAY;EACZ,kBAAmB;AACpB;AAED;EACE,sBAAuB;AACxB;AAED;EACE;;;;IAIE,mDAAoD;EACrD;AACF;AAED;EACE;IACE,mBAAoB;IACpB,2CAA4C;IAC5C,0BAA2B;IAC3B,eAAgB;IAChB,WAAY;IACZ,8CAA+C;IAC/C,qBAAsB;IACtB,mCAAoC;EACrC;EAED;IACE,sCAAuC;IACvC,6CAA8C;EAC/C;EAED;;IAEE,WAAY;IACZ,eAAgB;IAChB,mBAAoB;IACpB,wCAAyC;IACzC,qCAAsC;IACtC,kBAAmB;IACnB,iBAAkB;IAClB;0BACuB;EACxB;EAED;;IAEE,aAAc;IACd,2BAA4B;IAC5B,6CAA8C;IAC9C,2BAA4B;EAC7B;EAED;;IAEE,2BAA4B;EAC7B;EAED;IACE,oBAAqB;IACrB,eAAgB;IAChB,eAAgB;IAChB,oBAAqB;IACrB,0CAA2C;IAC3C,oCAAqC;IACrC,YAAa;IACb,QAAS;EACV;EAED;IACE,oBAAqB;IACrB,eAAgB;IAChB,iBAAkB;IAClB,iBAAkB;IAClB,gBAAiB;IACjB,sBAAuB;IACvB,yBAA0B;IAC1B,mBAAoB;IACpB,0BAA2B;EAC5B;EAED;IACE,iBAAkB;IAClB,iBAAkB;IAClB,6CAA8C;EAC/C;EAED;IACE,yBAA0B;IAC1B,sBAAuB;IACvB,gBAAiB;IACjB,qBAAsB;IACtB,kBAAmB;IACnB,kBAAmB;IACnB,eAAgB;EACjB;EAED;IACE,YAAa;EACd;EAED;IACE,YAAa;EACd;EAED;IACE;MACE,sBAAuB;IACxB;EACF;EACD;IACE,kBAAmB;IACnB,aAAc;IACd,mBAAoB;IACpB,oBAAqB;IACrB,uBAAwB;IACxB,gBAAiB;IACjB,iBAAkB;IAClB,kBAAmB;EACpB;EAED;IACE,UAAW;IACX,WAAY;IACZ,sBAAoB;OAApB,mBAAoB;IACpB,kBAAmB;IACnB,UAAW;IACX,YAAa;EACd;EAED;;;IAGE,kBAAmB;IACnB,SAAU;IACV,QAAS;IACT,gCAAiC;IACjC,oBAAqB;EACtB;EAED;IACE,UAAW;IACX,sBAAuB;IACvB,aAAc;IACd,YAAa;EACd;EAED;IACE,UAAW;IACX,aAAc;IACd,sBAAuB;EACxB;EAED;IACE,UAAW;IACX,YAAa;IACb,sBAAuB;EACxB;EAED;IACE,kBAAmB;IACnB,SAAU;IACV,UAAW;IACX,WAAY;IACZ,YAAa;IACb,oBAAqB;IACrB;;;;;;;;;OAUI;IACJ,aAAc;IACd,YAAa;IACb,sBAAuB;IACvB,UAAW;IACX,eAAgB;IAChB,oBAAqB;IACrB;;;;KAIE;IACF;;;;KAIE;EACH;EAED;IACE;;;;;;;;;;;;;;KAcE;IACF,0BAA2B;IAC3B,eAAgB;EACjB;EAGH;IACE,eAAgB;IAChB,SAAU;IACV,OAAQ;IACR,QAAS;IACT,+DAAgE;IAChE,qCAAsC;IACtC,qBAAsB;IACtB,8CAA+C;IAC/C,4CAA6C;IAC7C,2BAA4B;IAC5B,UAAW;IACX,oDAAqD;IACrD,WAAY;EACb;EAEC;IACE,wBAAyB;IACzB,UAAW;EACZ;EAEH;IACE,gBAAiB;IACjB,cAAe;IACf,qBAAsB;IACtB,kCAAmC;IACnC,0CAA2C;IAC3C,qCAAsC;IACtC,aAAc;IACd,mBAAoB;IACpB,8BAA+B;IAC/B,SAAU;EACX;EAED;IACE,kBAAmB;IACnB,yBAA0B;IAC1B,qBAAsB;IACtB,mBAAoB;EACrB;EAED;IACE,eAAgB;IAChB,kBAAmB;IACnB,mBAAoB;EACrB;EAED;IACE,WAAY;IACZ,YAAa;IACb,oBAAqB;IACrB,0CAA2C;IAC3C,iBAAkB;IAClB,iBAAkB;IAClB,gBAAiB;IACjB,aAAc;IACd,mBAAoB;IACpB,6CAA8C;EAC/C;EAED;IACE,oBAAqB;IACrB,mBAAoB;IACpB,QAAS;EACV;EAED;IACE,oBAAqB;IACrB,yBAA0B;IAC1B,YAAa;IACb,kBAAmB;IACnB,gBAAiB;IACjB,iBAAkB;IAClB,gDAAiD;EAClD;EAED;IACE,gBAAiB;IACjB,kBAAmB;IACnB,WAAY;IACZ,oBAAqB;IACrB,kCAAmC;IACnC,gBAAiB;EAClB;EAED;IACE,YAAa;IACb,oBAAqB;IACrB,kEAAmE;IACnE,gBAAiB;EAClB;EAED;IACE,eAAgB;IAChB,QAAS;IACT,WAAY;IACZ,aAAc;IACd,mBAAoB;IACpB,aAAc;EACf;EAED;IACE,kBAAmB;IACnB,QAAS;IACT,kCAAmC;IACnC,qBAAsB;IACtB,YAAa;EACd;EAED;IACE,kBAAmB;IACnB,UAAW;IACX,uBAAwB;IACxB,mBAAoB;IACpB,qCAAsC;IACtC,0CAA2C;IAC3C,8CAA+C;IAC/C,aAAc;EACf;EAED;IACE,eAAgB;IAChB,gBAAiB;IACjB,iBAAkB;EACnB;EAED;IACE,gBAAiB;IACjB,YAAa;IACb,oBAAqB;IACrB,kCAAmC;IACnC,gBAAiB;EAClB;EAED;IACE,YAAa;IACb,oBAAqB;IACrB,kEAAmE;IACnE,4BAA6B;EAC9B;EAED;IACE,kBAAmB;IACnB,yBAA0B;IAC1B,sBAAuB;IACvB,mBAAoB;EACrB;AACA;AAED;EACE;IACE,eAAgB;EACjB;EAED;IACE,eAAgB;EACjB;AACF;AAED;EACE;IACE,qBAAsB;EACvB;EAED;IACE,oBAAqB;EACtB;EAED;IACE,cAAe;EAChB;EAED;IACE,aAAc;EACf;EAED;IACE,iBAAkB;EACnB;EAED;IACE,eAAgB;EACjB;EAED;IACE,aAAc;EACf;EAED;IACE,iBAAkB;IAClB,iBAAkB;EACnB;EAED;IACE,iBAAkB;EACnB;EAED;IACE,iBAAkB;IAClB,oBAAqB;EACtB;EAED;IACE,iBAAkB;EACnB;EAED;IACE,iBAAkB;EACnB;EAED;IACE,aAAc;EACf;EAED;;;IAGE,eAAgB;IAChB,uBAAwB;EACzB;EAED;;;IAGE,YAAa;EACd;EAED;;;IAGE,mBAAoB;EACrB;EAED;;;IAGE,cAAe;IACf,2BAA4B;EAC7B;EAED;IACE,WAAY;IACZ,8BAA+B;EAChC;EAED;;;IAGE,iBAAkB;EACnB;EAED;;IAEE,cAAe;EAChB;EAED;IACE,eAAgB;EACjB;AACF;AAED;EACE;IACE,eAAgB;EACjB;EAED;IACE,aAAc;EACf;AACF;AAED;EACE;IACE,kBAAmB;EACpB;EAED;IACE,kBAAmB;EACpB;EAED;IACE,iBAAkB;IAClB,oBAAqB;EACtB;EAED;IACE,QAAS;EACV;EAED;IACE,iBAAkB;IAClB,iBAAkB;EACnB;AACF;AAED;EACE;IACE,+BAAgC;EACjC;EAED;IACE,+BAAgC;EACjC;EAED;IACE,cAAe;IACf,kBAAmB;IACnB,SAAU;IACV,kBAAmB;EACpB;EAED;IACE,YAAa;IACb,oCAAqC;EACtC;EAED;IACE;;KAEE;EACH;EAED;IACE,eAAgB;IAChB,SAAU;IACV,0BAA2B;IAC3B,yCAA0C;IAC1C;;;KAGE;IACF,WAAY;IACZ,mBAAoB;IACpB,wCAAyC;IACzC,mBAAoB;IACpB,6CAA8C;IAC9C,uBAAwB;IACxB,gBAAiB;IACjB,UAAW;IACX,2BAA4B;IAC5B,oBAAqB;IACrB,oDAAqD;IACrD,+BAAgC;EACjC;EAED;IACE,UAAW;IACX,wBAAyB;IACzB,oBAAqB;EACtB;EAED;IACE,YAAa;IACb,gBAAiB;IACjB,UAAW;IACX,gBAAiB;IACjB,uBAAwB;IACxB,YAAa;IACb,gBAAiB;EAClB;EAED;IACE,mBAAoB;IACpB,gBAAiB;IACjB,qCAAsC;EACvC;EACD;IACE,iBAAkB;EACnB;EAED;IACE,WAAY;IACZ,oBAAqB;IACrB,iBAAkB;IAClB,kBAAmB;EACpB;EAED;IACE,YAAa;EACd;EAED;IACE,kBAAmB;IACnB,mBAAoB;IACpB,uBAAwB;IACxB,gBAAiB;IACjB,iBAAkB;EACnB;EAED;IACE,WAAY;IACZ,gBAAiB;IACjB,SAAU;IACV,wBAAoB;IAApB,mBAAoB;EACrB;EAED;IACE,mBAAoB;EACrB;EAED;IACE,aAAc;IACd,SAAU;IACV,gBAAiB;EAClB;EAED;IACE,aAAc;IACd,8CAA+C;EAChD;EAED;;IAEE,kBAAmB;EACpB;EAED;IACE,kBAAmB;EACpB;EAED;IACE,iBAAkB;EACnB;EAED;IACE,kBAAmB;EACpB;EAED;IACE,kBAAmB;EACpB;EAED;IACE,kBAAmB;EACpB;EAED;IACE,mBAAoB;EACrB;EAED;IACE,kBAAmB;EACpB;EAED;IACE,YAAa;EACd;EAED;IACE,YAAa;EACd;EAED;IACE,mBAAoB;EACrB;EAED;IACE;;;;KAIE;EACH;AACF;AAED;EACE;IACE,eAAgB;EACjB;EAED;IACE,mBAAoB;EACrB;EAED;IACE,aAAc;EACf;EAED;IACE,WAAY;EACb;AACF;AAED;EACE;IACE,eAAgB;EACjB;AACF;AAED;EACE;;IAEE,0BAA2B;EAC5B;EACD;IACE,4BAA6B;EAC9B;AACF;AAED;EACE;;IAEE,0BAA2B;EAC5B;EACD;IACE,8BAA+B;EAChC;AACF;AAED;EACE;;IAEE,wCAAyC;IACzC,aAAc;EACf;EACD;IACE,gDAAiD;IACjD,YAAa;EACd;AACF;ADuHC;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AA2elB;EAAA;IAAA;MAAA,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap\");\n@import \"tailwindcss\";\n\n:root {\n  --bg: #f6f1e7;\n  --surface: rgba(255, 255, 255, 0.86);\n  --ink: #1f1b16;\n  --muted: #5c5650;\n  --accent: #e36c4f;\n  --accent-2: #1f7a72;\n  --accent-3: #f3b769;\n  --desktop-results-panel-width: 380px;\n  --page-max-width: 80rem;\n  --results-panel-gap: 24px;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Instrument Sans\", system-ui, sans-serif;\n  color: var(--ink);\n  background: var(--bg);\n  overflow-x: hidden;\n}\n\nhtml.results-only,\nbody.results-only {\n  overflow: hidden;\n}\n\nhtml {\n  background: var(--bg);\n  scroll-behavior: auto;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  overflow-x: hidden;\n}\n\n#root {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n@layer base {\n  h1,\n  h2,\n  h3,\n  h4 {\n    font-family: \"Space Grotesk\", system-ui, sans-serif;\n  }\n}\n\n@layer components {\n  .glass-card {\n    border-radius: 24px;\n    border: 1px solid rgba(255, 255, 255, 0.65);\n    background: var(--surface);\n    max-width: 100%;\n    width: 100%;\n    box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n    backdrop-filter: none;\n    transition: border-color 220ms ease;\n  }\n\n  .glass-card:hover {\n    border-color: rgba(255, 255, 255, 0.9);\n    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.1);\n  }\n\n  .input-field,\n  .select-field {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 14px;\n    border: 1px solid rgba(15, 23, 42, 0.12);\n    background: rgba(255, 255, 255, 0.92);\n    padding: 10px 12px;\n    font-size: 0.9rem;\n    transition: border 160ms ease, box-shadow 160ms ease,\n      transform 160ms ease;\n  }\n\n  .input-field:focus,\n  .select-field:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 3px rgba(227, 108, 79, 0.2);\n    transform: translateY(-1px);\n  }\n\n  .input-field.is-error,\n  .select-field.is-error {\n    border-color: var(--accent);\n  }\n\n  .segmented {\n    display: inline-flex;\n    flex-wrap: wrap;\n    max-width: 100%;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.7);\n    background: rgba(255, 255, 255, 0.7);\n    padding: 4px;\n    gap: 4px;\n  }\n\n  .segmented-button {\n    border-radius: 999px;\n    max-width: 100%;\n    padding: 6px 12px;\n    font-size: 0.7rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--muted);\n    transition: all 150ms ease;\n  }\n\n  .segmented-button.is-active {\n    background: white;\n    color: var(--ink);\n    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);\n  }\n\n  .comparison-label {\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    line-height: 1.3;\n    overflow-wrap: normal;\n    word-break: normal;\n    text-wrap: balance;\n    hyphens: manual;\n  }\n\n  .comparison-card {\n    min-width: 0;\n  }\n\n  .glass-card > * {\n    min-width: 0;\n  }\n\n  @media (max-width: 640px) {\n    .comparison-label {\n      letter-spacing: 0.12em;\n    }\n  }\n  .fire-logo {\n    position: relative;\n    display: grid;\n    place-items: center;\n    border-radius: 999px;\n    background: transparent;\n    box-shadow: none;\n    overflow: visible;\n    isolation: isolate;\n  }\n\n  .fire-logo__img {\n    width: 70%;\n    height: 70%;\n    object-fit: contain;\n    position: relative;\n    z-index: 4;\n    filter: none;\n  }\n\n  .fire-logo__flames,\n  .fire-logo__smoke,\n  .fire-logo__embers {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -62%);\n    pointer-events: none;\n  }\n\n  .fire-logo__flames {\n    z-index: 2;\n    mix-blend-mode: normal;\n    opacity: 0.55;\n    filter: none;\n  }\n\n  .fire-logo__smoke {\n    z-index: 1;\n    opacity: 0.18;\n    mix-blend-mode: normal;\n  }\n\n  .fire-logo__embers {\n    z-index: 3;\n    opacity: 0.3;\n    mix-blend-mode: normal;\n  }\n\n  .fire-logo__heat {\n    position: absolute;\n    top: -35%;\n    left: -10%;\n    width: 120%;\n    height: 110%;\n    border-radius: 999px;\n    background-image:\n      radial-gradient(\n        60% 40% at 50% 60%,\n        rgba(255, 255, 255, 0.12),\n        transparent 70%\n      ),\n      radial-gradient(\n        40% 30% at 30% 40%,\n        rgba(255, 190, 120, 0.12),\n        transparent 70%\n      );\n    opacity: 0.12;\n    filter: none;\n    mix-blend-mode: normal;\n    z-index: 7;\n    animation: none;\n    pointer-events: none;\n    -webkit-mask-image: radial-gradient(\n      circle at 50% 60%,\n      rgba(0, 0, 0, 1),\n      transparent 70%\n    );\n    mask-image: radial-gradient(\n      circle at 50% 60%,\n      rgba(0, 0, 0, 1),\n      transparent 70%\n    );\n  }\n\n  .hero-gradient {\n    background-image: radial-gradient(\n        circle at 10% 10%,\n        rgba(243, 183, 105, 0.35),\n        transparent 55%\n      ),\n      radial-gradient(\n        circle at 80% 20%,\n        rgba(31, 122, 114, 0.25),\n        transparent 55%\n      ),\n      linear-gradient(\n        130deg,\n        rgba(255, 255, 255, 0.7),\n        rgba(255, 255, 255, 0.1)\n    );\n    background-size: 200% 200%;\n    animation: none;\n  }\n\n\n.accuracy-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 8px 12px calc(env(safe-area-inset-bottom, 0px) + 10px);\n  background: rgba(255, 255, 255, 0.82);\n  backdrop-filter: none;\n  border-top: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);\n  transform: translateY(110%);\n  opacity: 0;\n  transition: transform 220ms ease, opacity 220ms ease;\n  z-index: 50;\n}\n\n  .accuracy-bar.is-visible {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n.accuracy-bar__inner {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 8px 12px 6px;\n  border-radius: 16px 16px 10px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.92);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.accuracy-bar__label {\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.3em;\n  color: var(--muted);\n}\n\n.accuracy-bar__note {\n  margin-top: 4px;\n  font-size: 0.75rem;\n  color: var(--muted);\n}\n\n.accuracy-bar__help {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: white;\n  color: var(--ink);\n  font-weight: 700;\n  display: grid;\n  place-items: center;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);\n}\n\n.accuracy-bar__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.accuracy-bar__results {\n  border-radius: 999px;\n  background: var(--accent);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 6px 12px;\n  box-shadow: 0 10px 22px rgba(227, 108, 79, 0.25);\n}\n\n.accuracy-bar__track {\n  max-width: 640px;\n  margin: 6px auto 0;\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.accuracy-bar__fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--accent-2), var(--accent));\n  transition: none;\n}\n\n.accuracy-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 60;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n}\n\n.accuracy-modal__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.25);\n  backdrop-filter: none;\n  border: none;\n}\n\n.accuracy-modal__card {\n  position: relative;\n  z-index: 1;\n  width: min(92vw, 360px);\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);\n  padding: 18px;\n}\n\n.accuracy-modal__value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.accuracy-modal__track {\n  margin-top: 10px;\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.accuracy-modal__fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--accent-2), var(--accent));\n  transition: width 600ms ease;\n}\n\n.accuracy-modal__close {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: var(--muted);\n}\n}\n\n@layer utilities {\n  .animate-float {\n    animation: none;\n  }\n\n  .animate-float-slow {\n    animation: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .glass-card {\n    backdrop-filter: none;\n  }\n\n  body {\n    padding-bottom: 82px;\n  }\n\n  .accuracy-bar {\n    display: block;\n  }\n\n  .show-results-fab {\n    display: none;\n  }\n\n  .hero-container {\n    padding-top: 32px;\n  }\n\n  .hero-pill {\n    max-width: 100%;\n  }\n\n  .accuracy-gauge {\n    display: none;\n  }\n\n  .hero-title {\n    font-size: 1.8rem;\n    line-height: 1.25;\n  }\n\n  .hero-subtitle {\n    font-size: 0.9rem;\n  }\n\n  .hero-container {\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n\n  .accuracy-bar__inner {\n    padding: 8px 10px;\n  }\n\n  .accuracy-bar__note {\n    font-size: 0.7rem;\n  }\n\n  .accuracy-modal {\n    padding: 16px;\n  }\n\n  .workout-row,\n  .exercise-row,\n  .session-row {\n    flex-wrap: wrap;\n    align-items: flex-start;\n  }\n\n  .workout-row button,\n  .exercise-row button,\n  .session-row button {\n    min-width: 0;\n  }\n\n  .workout-row span,\n  .exercise-row span,\n  .session-row span {\n    white-space: normal;\n  }\n\n  .workout-row > button,\n  .exercise-row > button,\n  .session-row > button {\n    flex: 1 1 100%;\n    justify-content: flex-start;\n  }\n\n  .exercise-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .workout-row__remove,\n  .exercise-row__remove,\n  .session-row__remove {\n    margin-left: auto;\n  }\n\n  html.results-only,\n  body.results-only {\n    overflow: auto;\n  }\n\n  html.results-only {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 769px) {\n  html.results-only {\n    font-size: 15px;\n  }\n\n  .accuracy-bar {\n    display: none;\n  }\n}\n\n@media (max-width: 360px) {\n  .hero-title {\n    font-size: 1.55rem;\n  }\n\n  .hero-subtitle {\n    font-size: 0.85rem;\n  }\n\n  .hero-container {\n    padding-top: 18px;\n    padding-bottom: 18px;\n  }\n\n  .accuracy-bar__actions {\n    gap: 6px;\n  }\n\n  .accuracy-bar__results {\n    padding: 5px 10px;\n    font-size: 0.7rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .results-grid {\n    min-height: calc(100vh - 220px);\n  }\n\n  .results-panel--compact {\n    min-height: calc(100vh - 240px);\n  }\n\n  .results-layout--desktop {\n    display: block;\n    position: relative;\n    gap: 32px;\n    align-items: start;\n  }\n\n  .results-layout__main {\n    min-width: 0;\n    transition: padding-right 260ms ease;\n  }\n\n  .results-layout--desktop.is-expanded .results-layout__main {\n    padding-right: calc(\n      var(--desktop-results-panel-width) + var(--results-panel-gap)\n    );\n  }\n\n  .results-layout__panel {\n    position: fixed;\n    top: 24px;\n    height: calc(100vh - 48px);\n    width: var(--desktop-results-panel-width);\n    right: max(\n      16px,\n      calc((100vw - var(--page-max-width)) / 2 + 16px)\n    );\n    z-index: 20;\n    background: #ffffff;\n    border: 1px solid rgba(15, 23, 42, 0.08);\n    border-radius: 24px;\n    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.1);\n    padding: 20px 16px 24px;\n    overflow: hidden;\n    opacity: 0;\n    transform: translateX(16px);\n    pointer-events: none;\n    transition: opacity 260ms ease, transform 260ms ease;\n    will-change: opacity, transform;\n  }\n\n  .results-layout.is-expanded .results-layout__panel {\n    opacity: 1;\n    transform: translateX(0);\n    pointer-events: auto;\n  }\n\n  .results-layout__panel-inner {\n    height: 100%;\n    overflow-y: auto;\n    padding: 0;\n    border-radius: 0;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n  }\n\n  .results-layout__panel-inner .glass-card {\n    border-radius: 16px;\n    box-shadow: none;\n    background: rgba(255, 255, 255, 0.98);\n  }\n  #calculator {\n    overflow: visible;\n  }\n\n  .results-grid {\n    width: 100%;\n    align-items: stretch;\n    overflow: visible;\n    position: relative;\n  }\n\n  .results-grid > * {\n    min-width: 0;\n  }\n\n  .results-sidebar {\n    position: relative;\n    align-self: stretch;\n    background: transparent;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .results-sidebar__inner {\n    width: 100%;\n    position: sticky;\n    top: 24px;\n    height: fit-content;\n  }\n\n  .results-sidebar .glass-card {\n    border-radius: 20px;\n  }\n\n  .results-panel--compact {\n    display: grid;\n    gap: 14px;\n    position: static;\n  }\n\n  .results-panel--compact .glass-card {\n    padding: 12px;\n    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);\n  }\n\n  .results-panel--compact h3,\n  .results-panel--compact h4 {\n    font-size: 0.98rem;\n  }\n\n  .results-panel--compact .text-lg {\n    font-size: 0.98rem;\n  }\n\n  .results-panel--compact .text-2xl {\n    font-size: 1.2rem;\n  }\n\n  .results-panel--compact .text-sm {\n    font-size: 0.78rem;\n  }\n\n  .results-panel--compact .text-xs {\n    font-size: 0.62rem;\n  }\n\n  .results-panel--compact .mt-6 {\n    margin-top: 0.5rem;\n  }\n\n  .results-panel--compact .mt-5 {\n    margin-top: 0.45rem;\n  }\n\n  .results-panel--compact .mt-4 {\n    margin-top: 0.4rem;\n  }\n\n  .results-panel--compact .gap-4 {\n    gap: 0.55rem;\n  }\n\n  .results-panel--compact .gap-3 {\n    gap: 0.45rem;\n  }\n\n  .results-panel--compact .rounded-2xl {\n    border-radius: 16px;\n  }\n\n  body.desktop-results-open .show-results-fab {\n    right: calc(\n      var(--desktop-results-panel-width) +\n        var(--results-panel-gap) +\n        24px\n    );\n  }\n}\n\n@media (min-width: 769px) and (max-height: 760px) {\n  html.results-only {\n    font-size: 14px;\n  }\n\n  .results-only-view > * + * {\n    margin-top: 0.35rem;\n  }\n\n  .results-only-view .glass-card {\n    padding: 10px;\n  }\n\n  .results-only-grid {\n    gap: 0.4rem;\n  }\n}\n\n@media (min-width: 769px) and (max-height: 680px) {\n  html.results-only {\n    font-size: 13px;\n  }\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-18px);\n  }\n}\n\n@keyframes gradientShift {\n  0%,\n  100% {\n    background-position: 0% 0%;\n  }\n  50% {\n    background-position: 100% 100%;\n  }\n}\n\n@keyframes heatShimmer {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0) scale(1);\n    opacity: 0.25;\n  }\n  50% {\n    transform: translate3d(2px, -6px, 0) scale(1.04);\n    opacity: 0.4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
